import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import dayjs from 'dayjs';
import { SAMPLES_FILE_UPDATE } from 'redux/actionTypes/samples';
import endUserMessages from 'utils/endUserMessages';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import UploadStatus from 'utils/upload/UploadStatus';
var updateSampleFileUpload = function updateSampleFileUpload(experimentId, sampleId, sampleFileId, type, uploadStatus, uploadProgress) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var updatedAt, url, body;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            updatedAt = dayjs().toISOString(); // Don't send an api update whenever the progress bar is updated, only for uploadStatus changes
            // TODO: move progress to not even be a part of redux, manage it in a different way
            if (!(uploadStatus !== UploadStatus.UPLOADING)) {
              _context.next = 14;
              break;
            }
            url = "/v2/experiments/".concat(experimentId, "/sampleFiles/").concat(sampleFileId);
            body = {
              uploadStatus: uploadStatus
            };
            _context.prev = 4;
            _context.next = 7;
            return fetchAPI(url, {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(body)
            });
          case 7:
            _context.next = 14;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](4);
            dispatch({
              type: SAMPLES_FILE_UPDATE,
              payload: {
                sampleUuid: sampleId,
                sampleFileType: type,
                lastModified: updatedAt,
                fileDiff: {
                  upload: {
                    status: UploadStatus.UPLOAD_ERROR
                  }
                }
              }
            });
            handleError(_context.t0, endUserMessages.ERROR_UPDATE_SERVER_ON_UPLOAD_STATE);
            return _context.abrupt("return");
          case 14:
            dispatch({
              type: SAMPLES_FILE_UPDATE,
              payload: {
                sampleUuid: sampleId,
                sampleFileType: type,
                lastModified: updatedAt,
                fileDiff: {
                  upload: {
                    status: uploadStatus,
                    progress: uploadProgress
                  }
                }
              }
            });
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 9]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default updateSampleFileUpload;